import { Component, Input, computed, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';
import { PipelineProgress } from '../../../core/models/api.models';

@Component({
  selector: 'app-pipeline-progress',
  standalone: true,
  template: `
    <aside class="flex max-w-3xl flex-col gap-2 border-l-2 border-sky-400 bg-sky-50/70 px-4 py-3 text-sm sm:flex-row sm:items-center sm:gap-3 dark:bg-sky-950/20">
      @if (progress) { <p class="min-w-0 flex-1 break-words text-slate-800 dark:text-slate-100">{{ progress.message }}</p> }
      <span role="timer" aria-live="off" class="shrink-0 text-xs tabular-nums text-slate-500 sm:ml-auto dark:text-slate-400">{{ elapsedTime() }}</span>
    </aside>
  `,
})
export class PipelineProgressComponent {
  @Input() progress: PipelineProgress | null = null;
  private readonly elapsedSeconds = signal(0);
  protected readonly elapsedTime = computed(() => {
    const seconds = this.elapsedSeconds();
    return `${Math.floor(seconds / 60).toString().padStart(2, '0')}:${(seconds % 60).toString().padStart(2, '0')}`;
  });

  constructor() {
    // Mounted for the entire send, independently of progress events.
    const startedAt = performance.now();
    interval(1000).pipe(takeUntilDestroyed()).subscribe(() => {
      this.elapsedSeconds.set(Math.floor((performance.now() - startedAt) / 1000));
    });
  }
}
